<template>
  <div
    class="i-unlock-careers"
    :class="{ 'not-compact': !props.isCompact }"
    @click="handleUpgradeClick()"
  >
    <div class="top">
      <img
        :src="iconLock"
        alt="Unlock icon"
      />
      <div>
        Unlock all career recommendations <span v-if="unlockQuantity"> (+{{ unlockQuantity }})</span>
      </div>
    </div>
    <div class="bottom">
      <div>Get them today</div>
      <a class="upgrade-button">
        <img
          :src="iconRocket"
          alt="Upgrade icon"
        />
        <span>Upgrade</span>
      </a>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useUserStore } from "@/stores/user"
import { computed } from "vue"

// ASSETS
import iconLock from "@/assets/icons/icon-blue-lock.svg"
import iconRocket from "@/assets/icons/icon-rocket.svg"

// TYPES
import ReportStatus from "@/shared/enums/ReportStatus"

// EMITS
const emit = defineEmits(["upgradeClicked"])

// PROPS
const props = defineProps({
  isCompact: {
    type: Boolean,
    default: false
  }
})

// STORES
const userStore = useUserStore()

// COMPUTED
const unlockQuantity = computed(() => {
  switch (userStore.getReportStatus) {
    case ReportStatus.FREE:
      return 9
    case ReportStatus.BASIC:
      return 5
    default:
      return null
  }
})

// FUNCTION
function handleUpgradeClick() {
  if (userStore.isTierComprehensiveOrHigher) return
  emit("upgradeClicked")
}
</script>

<style lang="scss" scoped>
.i-unlock-careers {
  width: 100%;

  @include flex(column, center, center, $gap: 15px);

  border: 1px solid $zumthor100;

  @include border-radius-md;

  padding: 24px;
  font-weight: 500;
  text-align: center;
  cursor: pointer;

  &:hover {
    border: 1px solid $azure-radiance200;
    background-color: $azure-radiance50;
  }

  &.not-compact {
    @media screen and (min-width: $breakpoint-lg) {
      @include flex(row, space-between, center, $gap: 5px);

      .top {
        @include flex(row, start, center, $gap: 10px);

        img {
          margin-top: 0;
          z-index: 0;
        }
      }
    }
  }

  .top {
    @include flex(column, center, center, $gap: 10px);
    @include text-sm;

    color: $pickle-bluewood950;

    img {
      margin-top: -42px;
      z-index: 1;
    }
  }

  .bottom {
    @include flex(row, center, center, $wrap: wrap, $gap: 10px);

    border: 1px solid $zumthor100;

    @include border-radius-sm;

    padding: 6px 14px;

    @include text-xs;

    color: $comet950;
    background-color: $white;

    .upgrade-button {
      @include flex(row, center, center, $gap: 4px);

      color: $azure-radiance700;
      text-decoration: none;
    }
  }
}
</style>
